// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ge-0";
export var actionModalContentContainer = "_ge-1";
export var createTagButton = "_ge-2";
export var footerContainer = "_ge-7";
export var fullWidthDivider = "_ge-3";
export var hasCreateTagButton = "_ge-4";
export var noCreateTagButton = "_ge-5";
export var tagsContainer = "_ge-6";
export var tagsModalContentContainer = "_ge-8";